/* eslint-disable react/prop-types */
// Imports
import React from "react";
import QuizScreenStart from "../../QuizScreenStart/jsx/index.jsx";
import QuizScreenFinish from "../../QuizScreenFinish/jsx/index.jsx";
import QuizScreenQuestions from "../../QuizScreenQuestions/jsx/index.jsx";

function QuizMain() {
    return (
        <>
            <QuizScreenStart />
            <QuizScreenQuestions />
            <QuizScreenFinish />
        </>
    );
}

export default QuizMain;
